import _classCallCheck from "/buddy/okroo-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/buddy/okroo-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import utils from "./Util";
import { Subject } from 'rxjs';

var Event =
/*#__PURE__*/
function () {
  /**
   * Creates a new event with a Name and some transformers
   * @param name The name of the Event
   * @param transformers The transformers functions
   * @throws an Error if the transformers are not an array
   * @throws an Error if the any if the transformers is not a function
   * @throws an Error if the transformers return an Undefined or Null value
   */
  function Event(name, transformers) {
    _classCallCheck(this, Event);

    utils.debug("v2/Event:constructor");
    this.name = utils.validateText(name);
    this.transformers = new Array();
    this.value = null;
    this.subject = new Subject();
    if (typeof transformers === "undefined") return;
    if (!Array.isArray(transformers)) throw new Error("Transformers must be an Array");
    if (transformers.length == 0) throw new Error("Transformers Array shouldn't be empty");
    transformers.forEach(function (transformer) {
      if (typeof transformer !== "function") throw new Error("All the transformers must be functions");
    });
    this.transformers = transformers;
  }
  /**
   * subscribe to theis event notifications
   * @param subscriber The function no be executed when this events its fired
   * @return subscription An object representing the subscription to the Event
   * @throws an Error if the subscriber is not a function
   */


  _createClass(Event, [{
    key: "subscribe",
    value: function subscribe(subscriber) {
      utils.debug("v2/Event:subscribe");
      if (typeof subscriber !== "function") throw new Error("subscriber must be a function");
      return this.subject.subscribe(subscriber);
    }
    /**
     * It fires the ocurrency of an event, execute every transformation and  every subscriber
     * @param eventData the data of the event
     */

  }, {
    key: "notify",
    value: function notify(eventData) {
      utils.debug("v2/Event:notify");

      if (this.subject.observers.length == 0) {
        console.warn("No subscriber for ".concat(this.name, ", no side effects generated"));
      }

      var data = eventData;
      this.transformers.forEach(function (transformer) {
        data = transformer(data);
      });
      this.value = data;
      this.subject.next(this.value);
    }
  }]);

  return Event;
}();

export default Event;